<template>
  <CDropdown
    v-if="visible"
    placement="bottom-end"
    :caret="false"
    in-nav
    class="c-header-nav-item mx-2"
    add-menu-classes="pt-0 pb-0 shadow-sm border-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cil-bell" size="xl"/>
        <CBadge v-if="count > 0" shape="pill" color="warning" class="hr-badge">{{ count }}</CBadge>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader tag="div" class="text-center py-2" color="light">
      <strong><i class="fas fa-user-tie mr-1"></i> Alertas RR.HH. ({{ count }})</strong>
    </CDropdownHeader>

    <div v-if="count > 0" class="hr-scroll">
      <!-- Contratos -->
      <template v-if="contracts.length">
        <div class="grp-label"><i class="fas fa-file-signature text-warning"></i> Contratos por vencer</div>
        <CDropdownItem v-for="a in contracts" :key="'c' + a.contract_id" class="border-bottom py-2 hr-item">
          <div class="d-flex align-items-start w-100">
            <CIcon :name="a.state === 'vencido' ? 'cil-ban' : 'cil-warning'" :class="a.state === 'vencido' ? 'text-danger' : 'text-warning'" class="mr-2" size="lg"/>
            <div class="flex-grow-1 overflow-hidden">
              <div class="hr-name">{{ a.full_name }}</div>
              <div class="small">
                Vence {{ fmtDate(a.end_date) }} ·
                <b v-if="a.days_left < 0" class="text-danger">venció hace {{ -a.days_left }}d</b>
                <b v-else class="text-warning">en {{ a.days_left }}d</b>
              </div>
            </div>
          </div>
        </CDropdownItem>
      </template>

      <!-- Vacaciones -->
      <template v-if="vacations.length">
        <div class="grp-label"><i class="fas fa-umbrella-beach text-info"></i> Vacaciones</div>
        <CDropdownItem v-for="a in vacations" :key="'v' + a.employee_id" class="border-bottom py-2 hr-item">
          <div class="d-flex align-items-start w-100">
            <CIcon name="cil-calendar" class="mr-2 text-info" size="lg"/>
            <div class="flex-grow-1 overflow-hidden">
              <div class="hr-name">{{ a.full_name }}</div>
              <div class="small">Cumple {{ a.years_completed }} año(s) {{ fmtDate(a.anniversary) }} · <b class="text-info">en {{ a.days_left }}d</b></div>
            </div>
          </div>
        </CDropdownItem>
      </template>

      <!-- Retorno de vacaciones -->
      <template v-if="vacationsEnding.length">
        <div class="grp-label"><i class="fas fa-plane-arrival text-success"></i> Retorno de vacaciones</div>
        <CDropdownItem v-for="a in vacationsEnding" :key="'ve' + a.vacation_id" class="border-bottom py-2 hr-item">
          <div class="d-flex align-items-start w-100">
            <CIcon name="cil-airplane-mode" class="mr-2 text-success" size="lg"/>
            <div class="flex-grow-1 overflow-hidden">
              <div class="hr-name">{{ a.full_name }}</div>
              <div class="small">
                Hasta {{ fmtDate(a.end_date) }} ·
                <b v-if="a.days_left < 0" class="text-danger">retorno vencido {{ -a.days_left }}d</b>
                <b v-else class="text-success">retorna en {{ a.days_left }}d</b>
              </div>
            </div>
          </div>
        </CDropdownItem>
      </template>
    </div>

    <div v-else class="text-center py-4 text-muted">
      <CIcon name="cil-check-circle" size="xl" class="text-success mb-2 d-block mx-auto"/>
      Sin alertas de contratos ni vacaciones
    </div>

    <CDropdownHeader tag="div" class="text-center py-1 border-top" color="light">
      <small>Actualizado: {{ lastUpdate }}</small>
    </CDropdownHeader>
  </CDropdown>
</template>

<script>
import axios from 'axios'

const MONTHS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];

export default {
  name: 'TheHeaderDropdownHrAlerts',
  data() {
    return { contracts: [], vacations: [], vacationsEnding: [], count: 0, lastUpdate: '', interval: null };
  },
  computed: {
    apiUrl() { return this.$store.getters.get__url; },
    token() { return this.$store.getters.get__token; },
    campu() { return this.$store.getters.get_campu; },
    visible() {
      const ids = [];
      const rol = this.$store.getters.get_rol;
      if (rol && rol.id) ids.push(rol.id);
      const roles = this.$store.getters.get_roles;
      if (Array.isArray(roles)) roles.forEach(r => ids.push(r.id || r));
      return ids.some(id => [1, 14].includes(Number(id)));
    },
  },
  watch: {
    visible: { handler(v) { if (v) this.fetchAlerts(); }, immediate: true },
    campu(v) { if (v && this.visible) this.fetchAlerts(); },
  },
  methods: {
    fmtDate(d) {
      if (!d) return "—";
      const dt = new Date(String(d).substring(0, 10) + "T00:00:00");
      if (isNaN(dt)) return d;
      return `${String(dt.getDate()).padStart(2, "0")} ${MONTHS[dt.getMonth()]}`;
    },
    async fetchAlerts() {
      if (!this.visible || !this.token) return;
      try {
        const res = await axios.get(`${this.apiUrl}/contracts/alerts?days=30`, { headers: { Authorization: `Bearer ${this.token}` } });
        const data = res.data && res.data.data;
        if (data) {
          this.contracts = data.contracts || [];
          this.vacations = data.vacations || [];
          this.vacationsEnding = data.vacations_ending || [];
          this.count = data.count || (this.contracts.length + this.vacations.length + this.vacationsEnding.length);
          this.lastUpdate = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }
      } catch (e) {
        console.error("Error fetching HR alerts:", e);
      }
    },
  },
  mounted() {
    this.interval = setInterval(this.fetchAlerts, 300000); // 5 min
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
}
</script>

<style scoped>
.hr-badge { position: absolute; top: 0; right: 0; font-size: 10px; color: #000; }
.hr-scroll { max-height: 420px; overflow-y: auto; width: 380px; }
.grp-label { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; color: #768192; background: #f4f5f7; padding: 5px 12px; }
.hr-item { width: 100%; cursor: pointer; background: #fff; white-space: normal; }
.hr-item:hover { background: #f8f9fa; }
.hr-name { font-weight: 600; font-size: 0.86rem; color: #3c4b64; line-height: 1.2; }
.hr-scroll::-webkit-scrollbar { width: 5px; }
.hr-scroll::-webkit-scrollbar-thumb { background: #ccc; border-radius: 10px; }

/* Modo oscuro */
.c-dark-theme .grp-label { background: #23242c; color: #a9adba; }
.c-dark-theme .hr-item { background: #2a2b36; }
.c-dark-theme .hr-item:hover { background: #34353f; }
.c-dark-theme .hr-name { color: #e1e1e6; }
</style>
